<div class="content">
  @for (message of messages; track message) {
    <p class="message-entry">{{ message }}</p>
  }
</div>
<div class="buttonBar">
  <button class="warn-button" matButton="elevated" (click)="cancel()">{{ cancelButtonText }}</button>
  <span class="spacer"></span>
  <button class="primary-button" matButton="elevated" (click)="accept()">{{ acceptButtonText }}</button>
</div>
